import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { LoggedInRouteProps } from "./interfaces";
import { ThisPaths } from "../shared/Constants";
import { IState } from "../app-state/reducer";
import { toast } from "react-toastify";

// handle the private routes
const PrivateRoute: React.FC<LoggedInRouteProps> = ({
    path,
    exact = false,
    component: Component,
}) => {
    const isLoggedIn = useSelector<IState, boolean>(
        (state) => state.isLoggedIn
    );

    if (!isLoggedIn) toast.info("Sesión finalizada!");

    return (
        <Route
            path={path}
            exact={exact}
            render={(props) =>
                isLoggedIn ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: ThisPaths.LOGIN,
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
